import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter, matchPath } from 'react-router-dom';
import { TransitionGroup, Transition } from 'react-transition-group';
import { handleScreenEnterAnimation, handleScreenExitAnimation } from './animations';

import Connexion from './screens/Connexion';
import Erreur404 from './screens/Erreur404';
import Clients from './screens/Clients';
import InfoClient from './screens/InfoClient';
import Parametres from './screens/Parametres';
import Deconnexion from './screens/Deconnexion';

const routes = [
  {
    component: Connexion,
    key: 'home',
    path: '',
    id: 'home',
    title: 'Connexion',
    description: 'Pour accéder à votre compte AIDE, merci de saisir vos identifiants',
    exact: true,
    privateRoute: false,
    transitionAnimation: true
  },
  {
    component: Connexion,
    key: 'home',
    path: '/index.html',
    id: 'home',
    title: 'Connexion',
    description: 'Pour accéder à votre compte AIDE, merci de saisir vos identifiants',
    exact: true,
    privateRoute: false,
    transitionAnimation: true
  },
  {
    component: Connexion,
    key: 'connexion',
    path: '/connexion',
    id: 'home',
    title: 'Connexion',
    description: 'Pour accéder à votre compte AIDE, merci de saisir vos identifiants',
    exact: true,
    privateRoute: false,
    transitionAnimation: true
  },
  {
    component: Clients,
    key: 'clients',
    path: '/clients',
    id: 'clients',
    title: 'Clients',
    description: `Clients ADS`,
    exact: true,
    privateRoute: true,
    transitionAnimation: true
  },
  {
    component: InfoClient,
    key: 'info-client',
    path: '/client/:iPKClient?',
    id: 'info-client',
    title: 'Client',
    description: `Client`,
    exact: true,
    privateRoute: true,
    transitionAnimation: true
  },
  {
    component: Parametres,
    key: 'parameters',
    path: '/parametres',
    id: 'parameters',
    title: 'Paramètres',
    description: `Paramètres de l'application`,
    exact: true,
    privateRoute: true,
    transitionAnimation: true
  },
  {
    component: Deconnexion,
    key: 'deconnexion',
    path: '/deconnexion',
    id: 'home',
    title: 'Déconnexion',
    description: `Vous avez fermé votre session sur l'application AIDE`,
    exact: true,
    privateRoute: false,
    transitionAnimation: true
  }
];

const filterRoutes = location =>
  routes.filter(
    ({ path, privateRoute, exact, transitionAnimation }) =>
      !!matchPath(location.pathname, {
        path,
        privateRoute,
        exact,
        transitionAnimation
      })
  );

class Routes extends Component {
  selectTransitionAnimation = () => ({
    enter: handleScreenEnterAnimation,
    exit: handleScreenExitAnimation,
    delay: 1000
  });

  render() {
    const { isAuthenticated, animatedTransitions, location } = this.props;
    let anims = this.selectTransitionAnimation();
    const selected = filterRoutes(location);

    return (
      <Switch>
        <Route
          path={selected.length > 0 ? selected[0].path : ''}
          exact
          render={props => {
            if (selected.length === 0) {
              return (
                <TransitionGroup appear exit>
                  <Transition
                    key={404}
                    timeout={anims.delay}
                    onEnter={anims.enter}
                    onEntering={() => {}}
                    onEntered={() => {}}
                    onExit={anims.exit}
                    onExiting={() => {}}
                    onExited={() => {}}
                  >
                    <Suspense fallback={<div>Chargement...</div>}>
                      <Erreur404 />
                    </Suspense>
                  </Transition>
                </TransitionGroup>
              );
            }

            if (selected[0].privateRoute === true && !isAuthenticated) {
              return <Redirect to="/connexion" />;
            }

            if (animatedTransitions === false || selected[0].transitionAnimation === false) {
              anims = { enter: () => {}, exit: () => {}, delay: 0 };
            }

            if (animatedTransitions === true) {
              return (
                <TransitionGroup appear exit>
                  {selected.map(({ key, ...attribs }) => (
                    <Transition
                      key={`child-${key}`}
                      timeout={anims.delay}
                      onEnter={anims.enter}
                      onEntering={() => {}}
                      onEntered={() => {}}
                      onExit={anims.exit}
                      onExiting={() => {}}
                      onExited={() => {}}
                    >
                      <Suspense fallback={<div>Chargement...</div>}>
                        {React.createElement(
                          selected[0].component,
                          {
                            ...props,
                            ...attribs,
                            location
                          },
                          null
                        )}
                      </Suspense>
                    </Transition>
                  ))}
                </TransitionGroup>
              );
            }

            return (
              <Suspense fallback={<div>Chargement...</div>}>
                {React.createElement(
                  selected[0].component,
                  {
                    location
                  },
                  null
                )}
              </Suspense>
            );
          }}
        />
      </Switch>
    );
  }
}

Routes.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  animatedTransitions: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired
};

Routes.defaultProps = {
  animatedTransitions: true
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated
});

export default withRouter(connect(mapStateToProps)(Routes));
